import { render, staticRenderFns } from "./AxisX.vue?vue&type=template&id=7905da98&"
import script from "./AxisX.vue?vue&type=script&lang=ts&"
export * from "./AxisX.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports